import { FormFieldBase } from './form-field-base';

export class FormFieldTextbox extends FormFieldBase<string> {
  override controlType = 'textbox';
}
